import { render, staticRenderFns } from "./AnalysisTab.vue?vue&type=template&id=f9580000&scoped=true"
import script from "./AnalysisTab.vue?vue&type=script&lang=ts"
export * from "./AnalysisTab.vue?vue&type=script&lang=ts"
import style0 from "./AnalysisTab.vue?vue&type=style&index=0&id=f9580000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9580000",
  null
  
)

export default component.exports